import React from "react";

export const plotCoordinates = [
  { id: "villa-1",  coords: "2419,1069, 2420,1242, 2540,1242, 2492,1085", alt: "Villa 1" },
  { id: "villa-2",  coords: "2256,1040, 2257,1147, 2419,1147, 2418,1065", alt: "Villa 2" },
  { id: "villa-3",  coords: "2257,1147, 2257,1242, 2420,1242, 2419,1148", alt: "Villa 3" },
  { id: "villa-4",  coords: "2257,1244, 2257,1338, 2420,1337, 2420,1243", alt: "Villa 4" },
  { id: "villa-5",  coords: "2258,1338, 2257,1433,2419,1433, 2420,1338", alt: "Villa 5" },
  { id: "villa-6",  coords: "2420,1243, 2420,1433, 2597,1433, 2541,1242", alt: "Villa 6" },
  { id: "villa-7",  coords: "2453,1528, 2454,1655, 2551,1655, 2551,1527", alt: "Villa 7" },
  { id: "villa-8",  coords: "2356,1529, 2356,1655, 2453,1655, 2453,1528", alt: "Villa 8" },
  { id: "villa-9",  coords: "2258,1529, 2259,1655, 2356,1655, 2355,1528", alt: "Villa 9" },
  { id: "villa-10", coords: "2259,1656, 2258,1782, 2356,1782, 2356,1655", alt: "Villa 10" },
  { id: "villa-11", coords: "2356,1655, 2356,1782, 2452,1783, 2454,1656", alt: "Villa 11" },
  { id: "villa-12", coords: "2452,1657,2452,1781, 2551,1782, 2551,1656", alt: "Villa 12" },
  { id: "villa-13", coords: "2550,1655, 2551,1782, 2669,1782, 2633,1657", alt: "Villa 13" },
  { id: "villa-14", coords: "2573, 1876, 2573,2004, 2643,2005, 2726,1967, 2700,1875", alt: "Villa 14" },
  { id: "villa-15", coords: "2452,1877, 2452,2004, 2574,2003, 2572,1877", alt: "Villa 15" },
  { id: "villa-16", coords: "2035,2165, 2035,2259, 2164,2258, 2163,2169", alt: "Villa 16" },
  { id: "villa-17", coords: "2034,2069, 2034,2164, 2163,2163, 2163,2068", alt: "Villa 17" },
  { id: "villa-18", coords: "2033,1972, 2034,2068, 2163,2068, 2163,1972", alt: "Villa 18" },
  { id: "villa-19", coords: "2033,1877, 2033,1973, 2163,1973, 2163,1877", alt: "Villa 19" },
  { id: "villa-20", coords: "2033,1688,2032,1783, 2163,1783, 2162,1688", alt: "Villa 20" },
  { id: "villa-21", coords: "2033,1592, 2033,1689, 2162,1689, 2162,1592", alt: "Villa 21" },
  { id: "villa-22", coords: "2033,1497, 2032,1592, 2161,1592, 2162,1497", alt: "Villa 22" },
  { id: "villa-23", coords: "2033,1401, 2032,1497, 2162,1496, 2162,1401", alt: "Villa 23" },
  { id: "villa-24", coords: "2031,1307, 2032,1402,2162,1401, 2161,1305", alt: "Villa 24" },
  { id: "villa-25", coords: "2031,1210, 2031,1306, 2161,1305, 2161,1210", alt: "Villa 25" },
  { id: "villa-26", coords: "2031,1116, 2032,1210, 2160,1210, 2161,1115", alt: "Villa 26" },
  { id: "villa-27", coords: "2031,998, 2032,1115, 2161,1114, 2160,1021", alt: "Villa 27" },
  { id: "villa-28", coords: "1901,978, 1901,1115, 2030,1115, 2032,999", alt: "Villa 28" },
  { id: "villa-29", coords: "1902,1115, 1902,1210, 2030,1211, 2032,1115", alt: "Villa 29" },
  { id: "villa-30", coords: "1902,1211, 1902,1306, 2032,1308, 2032,1211", alt: "Villa 30" },
  { id: "villa-31", coords: "1902,1307, 1903,1401, 2032,1401, 2031,1307", alt: "Villa 31" },
  { id: "villa-32", coords: "1903,1401, 1902,1497, 2032,1496, 2032,1402", alt: "Villa 32" },
  { id: "villa-33", coords: "1903,1497,1903,1592, 2032,1591, 2032,1497", alt: "Villa 33" },
  { id: "villa-34", coords: "1904,1593,1902,1688, 2033,1689, 2031,1593", alt: "Villa 34" },
  { id: "villa-35", coords: "1904,1688, 1903,1783, 2032,1784, 2032,1689", alt: "Villa 35" },
  { id: "villa-36", coords: "1904,1879, 1904,1974, 2032,1972, 2033,1878", alt: "Villa 36" },
  { id: "villa-37", coords: "1904,1974, 1904,2068, 2032,2069, 2033,1973", alt: "Villa 37" },
  { id: "villa-38", coords: "1904,2069, 1904,2186, 2033,2186, 2034,2069", alt: "Villa 38" },
  { id: "villa-39", coords: "1676,2070, 1679,2165, 1807,2164, 1807,2069", alt: "Villa 39" },
  { id: "villa-40", coords: "1678,1975, 1677,2070, 1805,2069, 1806,1975", alt: "Villa 40" },
  { id: "villa-41", coords: "1677,1879, 1678,1973, 1806,1972, 1804,1878", alt: "Villa 41" },
  { id: "villa-42", coords: "1678,1689, 1676,1784, 1804,1785, 1805,1689", alt: "Villa 42" },
  { id: "villa-43", coords: "1677,1594,1676,1690, 1804,1688, 1806,1593", alt: "Villa 43" },
  { id: "villa-44", coords: "1676,1499, 1679,1594, 1805,1592, 1804,1498", alt: "Villa 44" },
  { id: "villa-45", coords: "1674,1403,1677,1497, 1804,1496, 1804,1402", alt: "Villa 45" },
  { id: "villa-46", coords: "1676,1308, 1676,1401, 1804,1402, 1805,1306", alt: "Villa 46" },
  { id: "villa-47", coords: "1678,1212, 1679,1307, 1805,1307, 1805,1211", alt: "Villa 47" },
  { id: "villa-48", coords: "1676,1115, 1676,1212, 1804,1209, 1805,1119", alt: "Villa 48" },
  { id: "villa-49", coords: "1677,1022, 1678,1115, 1805,1114, 1804,1019", alt: "Villa 49" },
  { id: "villa-50", coords: "1679,924, 1678,1021, 1804,1019, 1804,945", alt: "Villa 50" },
];

  const MapAreas = ({ onPlotEnter, onPlotLeave }) => {
   return (
     <map name="projectMap">
       {plotCoordinates.map((plot) => (
         <area
           key={plot.id}
           shape="poly"
           coords={plot.coords}
           href="#"
           alt={plot.alt}
           data-key={plot.id}
           onMouseEnter={() => onPlotEnter?.(plot.id)}
           onMouseLeave={() => onPlotLeave?.()}
           onFocus={() => onPlotEnter?.(plot.id)}
           onBlur={() => onPlotLeave?.()}
         />
       ))}
     </map>
   );
 };
 
 export default MapAreas;